import { Control, Controller } from 'react-hook-form';
import { PatternFormat } from 'react-number-format';

import FieldRow from 'components/FormElements/FieldRow';
import TextField from 'components/FormElements/AppTextInput';
import Spacing from 'components/Spacing';
import { BankAccountSettingsFormValues } from './BankAccountSettings';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

const BankAccountDetailsForFees: React.FC<{
  control: Control<BankAccountSettingsFormValues>;
}> = ({ control }) => {
  const [canEditFirm] = useHasPermissions([RolePermission.EditFirm]);

  return (
    <Spacing>
      <FieldRow title="Bank account name*" centerTitle>
        <Controller
          name="bankAccountForFeesExport.accountName"
          control={control}
          disabled={!canEditFirm}
          render={({ field: { ref, ...rest }, fieldState: { error } }) => (
            <TextField
              {...rest}
              inputRef={ref}
              placeholder="Enter bank account name"
              fullWidth
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </FieldRow>
      <FieldRow title="Bank account number*" centerTitle>
        <Controller
          name="bankAccountForFeesExport.accountNumber"
          control={control}
          disabled={!canEditFirm}
          render={({ field: { ref, ...rest }, fieldState: { error } }) => (
            <PatternFormat
              {...rest}
              inputRef={ref}
              placeholder="Enter bank account number"
              format="########"
              customInput={TextField}
              type="text"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </FieldRow>

      <FieldRow title="Bank account sort code*" centerTitle>
        <Controller
          name="bankAccountForFeesExport.accountSortCode"
          control={control}
          disabled={!canEditFirm}
          render={({ field: { ref, ...rest }, fieldState: { error } }) => (
            <PatternFormat
              {...rest}
              inputRef={ref}
              placeholder="Enter bank sort code"
              format="##-##-##"
              customInput={TextField}
              type="text"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </FieldRow>
      <FieldRow title="Bank transfer reference*" centerTitle>
        <Controller
          name="bankAccountForFeesExport.reference"
          control={control}
          disabled={!canEditFirm}
          render={({ field: { ref, ...rest }, fieldState: { error } }) => (
            <TextField
              {...rest}
              inputRef={ref}
              placeholder="Enter bank transfer reference"
              fullWidth
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </FieldRow>
    </Spacing>
  );
};

export default BankAccountDetailsForFees;
